import { gql } from '@apollo/client'
import {
  COMPETITORS_ATTRIBUTES,
} from 'config/apollo/fragments'

const STATION_QUERY = gql`
  query stationQuery($stationId: ID!) {
    station(id: $stationId) {
      id
      fuelGrades {
        fuelGrade {
          id
          shortTitle
          title
          primary
          secondary
        }
      }
      supportsPriceExecution
      posProviderKey
    }
  }
`

const STATION_COMPETITORS_QUERY = gql`
  query stationCompetitorsQuery($stationId: ID!) {
    station(id: $stationId) {
      id
      competitors {
        ...CompetitorsAttributes
      }
    }
  }
  ${COMPETITORS_ATTRIBUTES}
`

export { STATION_QUERY, STATION_COMPETITORS_QUERY }
